import queryString from 'query-string';
import { useEffect } from 'react';

const useVariablesFromQueryString = () => {
  const loadColors = () => {
    const queriedTheme = queryString.parse(window.location.search);
    const { primary } = queriedTheme;

    if (primary) {
      document.documentElement.style.setProperty('--primary', `#${primary}`);
    }
  };

  useEffect(() => {
    loadColors();
  }, []);
};

export default useVariablesFromQueryString;
